import apiClient from '@/core/api/';

//constants
const reportBaseApiURL = 'api/report';

export const getInvestigationRequestReport = async (
  requestNumber,
  isEn = false
) =>
  await apiClient.get(
    `${reportBaseApiURL}/investigationrequest/${requestNumber}`,
    {
      params: {
        isEn,
      },
    }
  );

  export const getAuthorizationLetterReport = async (
    requestNumber,
    isEn = false
  ) =>
    await apiClient.get(
      `${reportBaseApiURL}/authorizationLetter/${requestNumber}`,
      {
        params: {
          isEn,
        },
      }
    );
  